export default __webpack_public_path__ + "static/media/USDT.6dc09781.svg";